import { User } from "../types/user";

export function organizeUserData(data: User[]) {
  if (!data || data.length === 0) {
    return [];
  }
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }
  return data.map((val) => {
    return {
      firstName: val.firstName,
      lastName: val.lastName,
      identityNumber: val.identityNumber,
      role: val.role,
      email: val.email,
      center: val.center,
      status: val.status,
      relatedPatients: val.relatedPatients,
    };
  });
}
